import { useContext, useEffect, useState } from 'react';
import { GeneralContext } from '@/context/GeneralContext';
import { SECONDARY_NAVIGATION_FRAGMENT_STICKY_HEIGHT } from '@/components/SecondaryNavigation/SecondaryNavigation.styles';

const useHeaderHeight = () => {
  const [headerHeight, setHeaderHeight] = useState<number>(0);
  const { isInformationStripeVisible } = useContext(GeneralContext);

  useEffect(() => {
    const headerHeight = document.querySelector('[data-block-header]')?.clientHeight ?? 0;
    const informationStripeHeight =
      document.querySelector('[data-block-information-stripe]')?.clientHeight ?? 0;
    const hasSecondaryElement = !!document.querySelector('[data-block-secondary-navigation]');
    const secondaryNavHeight = Number(SECONDARY_NAVIGATION_FRAGMENT_STICKY_HEIGHT) - 2;

    setHeaderHeight(
      hasSecondaryElement ? secondaryNavHeight : headerHeight + informationStripeHeight
    );
  }, [isInformationStripeVisible]);

  return { headerHeight };
};

export default useHeaderHeight;
